import React from "react";

export type ExpandableTextProps = {
  className?: string;
  lines: number;
  less: any;
  more: any;
  text: string;
};

const ExpandableText = (props: ExpandableTextProps) => {
  const [mode, setMode] = React.useState<"more" | "less">("more");
  const [maxChars, setMaxChars] = React.useState<number>();
  const ref = React.useRef<HTMLDivElement>(null);

  const shouldTruncate = React.useMemo(() => {
    if (!ref.current) return false;

    const height = ref.current.offsetHeight;
    const style = window.getComputedStyle(ref.current);
    const lineHeight = parseInt(style.lineHeight);
    const lines = height / lineHeight;
    return lines > props.lines;
  }, [props.lines, ref.current]);

  React.useLayoutEffect(() => {
    if (!ref.current) return;

    if (mode === "less") {
      setMaxChars(undefined);
    } else {
      const style = window.getComputedStyle(ref.current);
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d")!;
      context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

      let text = ref.current.innerText.replace(/\.{3}$/, "");

      const containerWidth = ref.current.offsetWidth;
      let width = context.measureText(text).width;
      if (width > containerWidth) {
        let maxChars = text.length;

        while (width > containerWidth || Math.abs(containerWidth - width) > parseInt(style.fontSize) * 2) {
          if (width > containerWidth) {
            maxChars = maxChars / 2;
          } else {
            maxChars += 1;
          }

          width = context.measureText(text.substring(0, maxChars)).width;
        }

        setMaxChars(maxChars);
      }
    }
  }, [mode]);

  const finalText = React.useMemo(() => {
    if (maxChars) {
      return props.text.substring(0, maxChars) + "...";
    }

    return props.text;
  }, [props.text, maxChars]);

  return (
    <div className={props.className}>
      <div
        ref={ref}
        dangerouslySetInnerHTML={{
          __html: finalText
        }}
      />
      {shouldTruncate && (
        <div onClick={() => setMode(mode === "more" ? "less" : "more")}>
          {mode === "less" ? props.less : props.more}
        </div>
      )}
    </div>
  );
};

export default ExpandableText;
